// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1knic","info":"PatientInfo_info__1YJZq"};